// removed by extract-text-webpack-plugin
module.exports = {"top":"src-page-components-history----styles-module---top---1m7-O","topContent":"src-page-components-history----styles-module---topContent---2RMNK","content":"src-page-components-history----styles-module---content---1reqb"};


//////////////////
// WEBPACK FOOTER
// ./src/page-components/history/styles.module.css
// module id = 653
// module chunks = 65368489232520